import type { User } from "./schema";

export type ProfileData = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  emailVerified: boolean;
  phoneVerified: boolean;
  isHost: boolean;
};

/** Extract display-ready profile fields from the User record. */
export function extractProfile(user: User): ProfileData {
  return {
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email ?? "",
    phone: user.phone ?? "",
    emailVerified: user.email_verified,
    phoneVerified: user.phone_verified,
    isHost: user.is_host,
  };
}

/** Check which profile fields are still missing after auth. */
export function getMissingFields(user: User): (keyof ProfileData)[] {
  const missing: (keyof ProfileData)[] = [];
  if (!user.first_name?.trim()) missing.push("firstName");
  if (!user.last_name?.trim()) missing.push("lastName");
  if (!user.email?.trim()) missing.push("email");
  if (!user.phone?.trim()) missing.push("phone");
  return missing;
}
